import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { format } from "date-fns";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { IoCloseSharp, IoWarningOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { SwiperSlide } from "swiper/react";
import draft_img from "../../assets/icons/Draft_IMG.svg";
import remove_recipient from "../../assets/icons/remove_recipient.svg";
import ConfirmationModal from "../../components/ConfirmationModal";
import Modal from "../../components/Modal";
import MultiSwiper from "../../components/MultiSwiper";
import SidePanel from "../../components/SidePanel";
import Spinner from "../../components/Spinner";
import Tooltip from "../../components/Tooltip";
import {
  getAdjustedEventDate,
  getDateDifferenceInDays,
  handleDeleteCard,
} from "../../utils/sendToPrint";
import { CartContext } from "../../context/CartContext";
import CartSidebar from "../../components/CartSidebar";
import { CardsContext } from "../../context/CardsContext";
import { OpenCartContext } from "../../context/OpenCartContext";
const SendToPrint = () => {
  const { cart, fetchCart } = useContext(CartContext);
  const { setCustomerCards, customerCards, showPast, fetchCards } =
    useContext(CardsContext);

  const location = useLocation();
  const { setCartOpen } = useContext(OpenCartContext);

  const [tabclick, setTabClick] = useState("Current");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [groupedCards, setGroupedCards] = useState({});
  // const [customerCards, setCustomerCards] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedMonthFilter, setSelectedMonthFilter] = useState("");
  const [filteredCards, setFilteredCards] = useState({});
  const [cardToBeDelete, setCardToBeDelete] = useState({});
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRecipient, setSelectedRecipient] = useState("");
  const [currentEventId, setCurrentEventId] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [eventName, setEventName] = useState("");
  const [cardDetails, setCardDetails] = useState({
    eventOfRecipientId: "",
    textCard: "",
    eventId: {},
    cardStatus: "",
    textTo: "",
    textFrom: "",
    messageTheme: "",
    createdAt: "",
    cardId: {},
    receiptsId: {},
    eventDate: "",
  });
  const [occasions, setOccasions] = useState([]);
  const [orderLoader, setOrderLoader] = useState(null);
  const [removeModal, setRemoveModal] = useState(false);
  const token = useMemo(() => localStorage.getItem("token"), []);
  // const [showPast, setShowPast] = useState(false);
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const currentMonth = useMemo(() => new Date().getMonth(), []);
  const [isModalOpen, setIsModelOpen] = useState(false);
  const toggleModal = () => {
    setIsModelOpen(!isModalOpen);
  };
  const [selectedCardThumbnail, setSelectedCardThumbnail] = useState("");
  const [currentMonthCompletedLength, setCurrentMonthCompletedLength] =
    useState([]);
  const [upcomingMonthCompletedLength, setUpcomingMonthCompletedLength] =
    useState([]);
  const [cardImages, setCardImages] = useState({});
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState({
    0: false,
    1: true,
    2: true,
    3: true,
  });
  const [canEdit, setCanEdit] = useState(true);
  const [me, setMe] = useState("");
  const [currentUser, setCurrentUser] = useState({});

  const toggleRemoveModal = () => {
    setRemoveModal(!removeModal);
  };

  const handleScroll = (direction) => {
    setCurrentPage((prevPage) => {
      if (direction === "next" && prevPage < 3) {
        return prevPage + 1;
      } else if (direction === "prev" && prevPage > 0) {
        return prevPage - 1;
      }
      return prevPage;
    });
  };

  useEffect(() => {
    if (location.state?.openCart) {
      setCartOpen(true);
    }
  }, [location.state, setCartOpen]);

  useEffect(() => {
    setCurrentPage(0);
  }, [detailsModal]);

  const handleOrder = useCallback(
    async (ID, action, customerId, frozenDate) => {
      if (showPast || !ID) {
        toast.error("Ordering for past events is not permitted.");
        return;
      }

      setOrderLoader(ID);

      try {
        const url = new URL(
          `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/change-status/${ID}`
        );

        // Add query parameters
        url.searchParams.append(
          "status",
          action === "cancel" ? "pending" : "completed"
        );
        url.searchParams.append("customerId", customerId);

        // Conditionally add frozenDate
        if (frozenDate) {
          url.searchParams.append("frozenDate", frozenDate);
        }

        const res = await fetch(url.toString(), {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-sh-auth": token,
          },
        });
        const data = await res.json();
        setOrderLoader(null);
        if (data.code === 200) {
          toast.success(
            `Order ${action === "cancel" ? "Cancelled" : "Placed"} Successfully`
          );
          setCustomerCards((prev) =>
            prev.map((card) =>
              card._id === ID
                ? {
                    ...card,
                    status: action === "cancel" ? "pending" : "completed",
                    frozenDate: action === "cancel" ? null : frozenDate,
                  }
                : card
            )
          );
        } else if (
          data.message ===
          "Maximum limit of completed orders exceeded (3 orders allowed)."
        ) {
          toast.error(
            "Maximum limit of completed orders exceeded (3 orders allowed)."
          );
        } else if (
          data.message ===
          "Maximum limit of completed orders exceeded (4 orders allowed)."
        ) {
          toast.error(
            "You have reached the maximum limit of 4 completed orders."
          );
        } else if (
          data.code === 400 &&
          data.message ===
            "Your subscription is not active. Please subscribe to continue!"
        ) {
          toast.error("Please subscribe first!");
          toggleModal();
          // window.location.href = "/dashboard/premium_plan";
        } else {
          toast.error(data?.message || "An error occurred. Please try again.");
        }
      } catch (error) {
        console.log("error: ", error);
        setOrderLoader(null);
        toast.error("An error occurred. Please try again.");
      }
    },
    [showPast, token]
  );
  const eventDateWithCurrentYear = useMemo(() => {
    if (eventDate && cardDetails.createdAt) {
      const eventObject = occasions?.find(
        (el) => el._id === cardDetails.eventId
      );
      return getAdjustedEventDate(
        eventDate,
        cardDetails.createdAt,
        eventObject,
        cardDetails
      );
    }
  }, [eventDate, cardDetails.createdAt]);

  useEffect(() => {
    if (occasions && currentEventId) {
      const foundEvent = occasions.find(
        (occasion) => occasion._id === currentEventId
      );
      setEventName(foundEvent?.name || "");
    }
  }, [occasions, currentEventId]);

  useEffect(() => {
    const fetchOccasions = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/event/get-active-event`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
          }
        );
        const res = await response.json();
        if (res.code === 200) {
          setOccasions(res.data);
        }
      } catch (error) {
        toast.error("Failed to fetch occasions.");
      }
    };
    fetchOccasions();
  }, [token]);

  useEffect(() => {
    const fetchMe = async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-sh-auth": token,
        },
      });
      const data = await res.json();
      if (res.status === 200) {
        setMe(data.detail.fullName);
        setCurrentUser(data.detail);
      }
    };
    if (token) {
      fetchMe();
    }
  }, [token]);
  // const fetchCards = async () => {
  //   setLoader(true);
  //   try {
  //     const res = await fetch(
  //       `${process.env.REACT_APP_API_URL}/api/eventOfRecipient/get-customer-cards`,
  //       {
  //         method: "GET",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "x-sh-auth": token,
  //         },
  //       }
  //     );
  //     const data = await res.json();
  //     setLoader(false);
  //     if (data.data) {
  //       const currentDate = new Date();
  //       const filteredAndSortedCards = data.data
  //         .filter((card) => {
  //           const eventDate = new Date(card.eventDate);
  //           const createdAtDate = new Date(card.createdAt);
  //           const isPastEvent =
  //             eventDate < currentDate && card.status === "completed";
  //           // this was for completed in isPastEvent
  //           // && card.status === "completed"
  //           const isFutureEvent = eventDate > currentDate;
  //           return showPast
  //             ? isPastEvent
  //             : (isFutureEvent &&
  //                 (card.status === "pending" || card.status === "completed")) ||
  //                 (createdAtDate > eventDate &&
  //                   (card.status === "pending" || card.status === "completed"));
  //         })
  //         .sort((a, b) => (a.status === "completed" ? -1 : 1));
  //       const filteredResults = data?.data?.length
  //         ? data.data.filter((item) => item.status !== "draft")
  //         : [];

  //       setCustomerCards(filteredResults);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     toast.error("Failed to fetch cards.");
  //   }
  // };

  // const updateCardStatusLocally = (cardId, status) => {
  //   setCustomerCards(prev =>
  //     prev.map(card =>
  //       card._id === cardId ? { ...card, cartStatus: status } : card
  //     )
  //   );
  // };

  useEffect(() => {
    if (token) {
      fetchCards();
    }
  }, [token, showPast]);

  const groupCardsByYearAndMonth = useCallback(
    (cards, occasions) => {
      const result = cards.reduce((grouped, card) => {
        const eventObject = occasions?.find((el) => el._id === card.eventId);
        const adjustedEventDate = getAdjustedEventDate(
          card.eventDate,
          card.createdAt,
          eventObject,
          card
        );
        //console.log("adjustedEventDate",adjustedEventDate)
        const year = adjustedEventDate.getFullYear();
        const month = adjustedEventDate.toLocaleString("default", {
          month: "long",
        });

        if (!grouped[year]) {
          grouped[year] = {};
        }

        if (!grouped[year][month]) {
          grouped[year][month] = [];
        }

        if (card.status === "completed") {
          grouped[year][month].unshift(card);
        } else {
          grouped[year][month].push(card);
        }

        return grouped;
      }, {});

      //
      return result;
    },
    [getAdjustedEventDate]
  );

  const sortMonths = (months) => {
    const monthOrder = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    // const currentMonthIndex = new Date().getMonth();

    // const sortedMonths = [
    //   ...monthOrder.slice(currentMonthIndex),
    //   ...monthOrder.slice(0, currentMonthIndex),
    // ];

    return months.sort((a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b));
  };

  useEffect(() => {
    const grouped = groupCardsByYearAndMonth(customerCards, occasions);

    const sortedGroupedCards = Object.keys(grouped).reduce((acc, year) => {
      const months = Object.keys(grouped[year]);
      const sortedMonths = sortMonths(months);
      acc[year] = sortedMonths.reduce((monthAcc, month) => {
        monthAcc[month] = grouped[year][month];
        return monthAcc;
      }, {});
      return acc;
    }, {});

    setGroupedCards(sortedGroupedCards);
  }, [customerCards, groupCardsByYearAndMonth, occasions]);

  useEffect(() => {
    if (selectedMonthFilter) {
      const [selectedYear, selectedMonth] = selectedMonthFilter.split("-");

      if (
        groupedCards[selectedYear] &&
        groupedCards[selectedYear][selectedMonth]
      ) {
        const filtered = {
          [selectedYear]: {
            [selectedMonth]: groupedCards[selectedYear][selectedMonth],
          },
        };

        setFilteredCards(filtered);
      } else {
        setFilteredCards(groupedCards);
      }
    } else {
      setFilteredCards(groupedCards);
    }
  }, [groupedCards, selectedMonthFilter]);

  const toggleDetailsModal = () => {
    setSelectedRecipient("");
    setCurrentEventId("");
    setEventDate("");
    setCardDetails({
      eventOfRecipientId: "",
      textCard: "",
      cardStatus: "",
      textTo: "",
      textFrom: "",
      messageTheme: "",
      createdAt: "",
      cardId: {},
      receiptsId: {},
      eventId: {},
    });
    setDetailsModal((prev) => !prev);
  };

  const fetchCardDetails = useCallback(
    async (to, cont, _from) => {
      if (!to || !cont || !_from) {
        toast.error("Missing card details for generation.");
        return;
      }
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/customer/generate-temp-card-png`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
            body: JSON.stringify({
              greeting: to,
              body: cont,
              signoff: _from,
            }),
          }
        );
        const res = await response.json();
        if (res.code === 200) {
          setCardImages(res.data);
        } else {
          toast.error("Failed to generate card.");
        }
      } catch (error) {
        toast.error("Error while generating card.");
      } finally {
        setIsLoading(false);
      }
    },
    [token]
  );
  useEffect(() => {
    const currentDate = new Date();
    const daysDifference = eventDateWithCurrentYear
      ? getDateDifferenceInDays(currentDate, eventDateWithCurrentYear)
      : 0;
    setCanEdit(daysDifference >= 7);
  }, [eventDateWithCurrentYear]);

  const getImgSrc = (page) => {
    const placeholders = {
      0: selectedCardThumbnail,
      // 1:
      //   cardImages.page2 || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF",
      1:
        cardImages.page3 || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF",
      2: cardImages.last || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF",
    };
    return (
      placeholders[page] || "https://via.placeholder.com/480x672/FFFFFF/FFFFFF"
    );
  };

  const handleImageLoad = (page, error = false) => {
    if (error) {
    }
    setImageLoading((prev) => ({ ...prev, [page]: false }));
  };

  const handleAddToCart = useCallback(
    async (card) => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/cart/add`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-sh-auth": token,
            },
            body: JSON.stringify({
              eventOfRecipientsId: card._id,
              //  customerId: card.customerId,
            }),
          }
        );

        const data = await res.json();

        if (data.code === 200) {
          toast.success("Item added to cart");
          if (window.gtag) {
            window.gtag("event", "add_to_cart", {
              // currency: "INR",
              value: card?.price || 0,
              items: [
                {
                  item_id: card?._id,
                  item_name: card?.title || card?.name || "Unknown item",
                  price: card?.price || 0,
                  quantity: 1,
                },
              ],
            });
          }
          fetchCards();
          fetchCart();
        } else {
          toast.error(data?.message || "Failed to add item to cart");
        }
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong");
      }
    },
    [token]
  );

  useEffect(() => {
    setImageLoading((prev) => ({ ...prev, [currentPage]: true }));
  }, [currentPage]);
  const sortDataByMonth = (data) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let sortedData = {};

    Object.keys(data.past).forEach((month) => {
      sortedData[month] = data.past[month];
    });

    // Sort the object keys based on month order
    const sortedMonths = Object.keys(sortedData).sort(
      (a, b) => months.indexOf(a) - months.indexOf(b)
    );

    // Rebuild the data structure based on sorted months
    let sortedDataByMonth = {};
    sortedMonths.forEach((month) => {
      sortedDataByMonth[month] = sortedData[month];
    });

    return sortedDataByMonth;
  };

  // const sortedData = sortDataByMonth(data);
  const editCard = async (card) => {
    // Log card details
    const name = card?.receiptsId?.fullName;
    const recipientID = card?.receiptsId?._id;
    const relationship = card?.receiptsId?.relationShip;
    const eventId = card?.eventId;
    const birthday =
      card?.receiptsId?.dob && format(card?.receiptsId?.dob, "yyyy-MM-dd");
    const gender = card?.receiptsId?.gender;
    const character_traits = card?.receiptsId?.characterTraits;
    const messageTheme = card?.messageTheme;
    const selectedCard = card?.cardId?.thumbnail;
    const selectedCardID = card?.cardId?._id;
    const occasion = occasions.find((o) => o._id === eventId)?.name;
    const greetings = card?.textTo;
    const text = card?.textCard;
    const signoff = card?.textFrom;
    const EventOfRecipientId = card?.eventOfRecipientId;
    const eventDate = card?.eventDate;

    // Add newline character to each line of the text
    // text = text.split('\n').map(line => line + '\n').join('');

    // Log all the values to check what's missing

    if (
      !name ||
      !recipientID ||
      !relationship ||
      !eventId ||
      !birthday ||
      !gender ||
      !character_traits ||
      !messageTheme ||
      !selectedCard ||
      !selectedCardID ||
      !me ||
      !occasion ||
      !greetings ||
      !text ||
      !EventOfRecipientId ||
      !signoff
    ) {
      toast.error(
        "Some data is missing. Please check the console for details."
      );
    } else {
      window.location.href =
        "/dashboard/card_generation/pick?name=" +
        name +
        "&recipientID=" +
        recipientID +
        "&relationship=" +
        relationship +
        "&occasion=" +
        occasion +
        "&eventId=" +
        eventId +
        "&birthday=" +
        birthday +
        "&gender=" +
        gender +
        "&character_traits=" +
        character_traits +
        "&messageTheme=" +
        messageTheme +
        "&me=" +
        me +
        "&thumbnail=" +
        selectedCard +
        "&selectedCardID=" +
        selectedCardID +
        "&greetings=" +
        greetings +
        "&text=" +
        encodeURIComponent(text) +
        "&signoff=" +
        signoff +
        "&eventOfRecipientId=" +
        EventOfRecipientId +
        "&fromNavigatedPageName=SendToPrint" +
        "&page=3&eventDate=" +
        eventDate;
    }
  };

  const filterCardsByYear = useCallback((filteredCards, tabclick) => {
    if (!filteredCards || Object.keys(filteredCards).length === 0) {
      return {};
    }

    const currentYear = new Date().getFullYear();
    const currentMonthName = new Date().toLocaleString("default", {
      month: "long",
    });

    if (tabclick === "Current") {
      const current = Object.entries(filteredCards).reduce(
        (acc, [year, months]) => {
          if (Number(year) === currentYear) {
            acc[year] = months;
          }
          return acc;
        },
        {}
      );

      return current;
    } else if (tabclick === "Upcoming") {
      const upcoming = Object.entries(filteredCards).reduce(
        (acc, [year, months]) => {
          const yearNum = Number(year);

          if (yearNum > currentYear) {
            acc[year] = months;
          }
          // else if (yearNum === currentYear) {
          //   const upcomingMonths = Object.keys(months).filter(
          //     (month) =>
          //       new Date(`${month} 1, ${currentYear}`).getMonth() >
          //     new Date().getMonth()
          //   );
          //
          //   if (upcomingMonths.length > 0) {
          //     acc[year] = upcomingMonths.reduce((monthAcc, month) => {
          //       monthAcc[month] = months[month];
          //       return monthAcc;
          //     }, {});
          //   }
          // }
          return acc;
        },
        {}
      );

      return upcoming;
    } else if (tabclick === "Past") {
      const past = Object.entries(filteredCards).reduce(
        (acc, [year, months]) => {
          const yearNum = Number(year);

          if (yearNum < currentYear) {
            const monthsArr = Object.keys(months);

            for (let i = 0; i < monthsArr.length; i++) {
              if (months[monthsArr[i]]) {
                if (acc["past"]?.[monthsArr[i]]) {
                  acc["past"][monthsArr[i]] = acc["past"]?.[
                    monthsArr[i]
                  ].concat(months[monthsArr[i]]);
                } else {
                  acc["past"] = {
                    ...acc["past"],
                    [monthsArr[i]]: months[monthsArr[i]],
                  };
                }
              }
            }
          }
          // else if (yearNum === currentYear) {
          //   const pastMonths = Object.keys(months).filter(
          //     (month) =>
          //       new Date(`${month} 1, ${currentYear}`).getMonth() <
          //       new Date().getMonth()
          //   );
          //   if (pastMonths.length > 0) {
          //     acc[year] = pastMonths.reduce((monthAcc, month) => {
          //       monthAcc[month] = months[month];
          //       return monthAcc;
          //     }, {});
          //   }
          // }
          return acc;
        },
        {}
      );

      const newPast =
        Object.keys(past)?.length > 0 && sortDataByMonth({ ...past });

      return newPast ? { past: newPast } : { past: {} };
    }

    return {};
  }, []);

  const filteredYearData = filterCardsByYear(filteredCards, tabclick);
  // Compute the completed cards using useMemo
  const statusCompleted = useMemo(() => {
    if (tabclick === "Current" && filteredYearData) {
      let completedItems = [];

      // Iterate and collect completed items
      Object.entries(filteredYearData).forEach(([year, monthData]) =>
        Object.entries(monthData).forEach(([month, cards]) => {
          cards.forEach((item) => {
            if (item.status === "completed") {
              completedItems.push(item);
            }
          });
        })
      );

      return completedItems;
    }
    return [];
  }, [filteredYearData, tabclick]);
  useEffect(() => {
    setCurrentMonthCompletedLength((prev) => {
      if (prev.length !== statusCompleted.length) {
        return statusCompleted;
      }
      return prev;
    });
  }, [statusCompleted]);

  const cardsLimit = 4;

  // Automatically handle excess completed orders
  useEffect(() => {
    const excessCount = statusCompleted.length - cardsLimit;

    if (excessCount > 0) {
      // Cancel excess completed orders
      const excessCards = statusCompleted.slice(0, excessCount);

      // Call handleOrder to cancel each excess card
      excessCards.forEach((card) => {
        // handleOrder(card._id, "cancel", card.customerId); // Cancel each excess card
      });
    }
  }, [statusCompleted, cardsLimit]);

  const handleUpcomingMonthComplete = (month, monthData) => {
    const resultArr = monthData[month].filter(
      (item) => item.status === "completed"
    );
    if (resultArr?.length >= cardsLimit) {
      setUpcomingMonthCompletedLength(resultArr.length);
      return true;
    } else {
      if (upcomingMonthCompletedLength) {
        setUpcomingMonthCompletedLength(0);
      }
      return false;
    }
  };

  return (
    <section className="flex flex-col lg:flex-row px-4 sm:px-3 md:px-6 lg:px-4 xl:px-4 mx-auto overflow-x-hidden">
      <SidePanel />

      {detailsModal && (
        <Modal toggleDetailsModal={toggleDetailsModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-secondary w-full px-6 py-4 mb-4 rounded-t-xl flex items-center justify-between shadow-lg">
              <h1 className="text-2xl text-white font-bold">Card Details</h1>
              <IoCloseSharp
                size={30}
                color="white"
                className="cursor-pointer hover:bg-gray-600 p-2 rounded-full"
                onClick={toggleDetailsModal}
              />
            </div>
            <div className="flex flex-col md:flex-row items-start justify-between p-6 w-full bg-white rounded-b-xl shadow-xl overflow-hidden">
              <div
                className="text-lg text-gray-800 w-full md:w-1/2 md:pr-4 space-y-4 overflow-auto"
                style={{ maxHeight: "500px" }}
              >
                <div className="space-y-1">
                  <button
                    disabled={!canEdit}
                    className={`flex items-center justify-center gap-x-2 bg-primary text-white text-xl py-2.5 my-3 w-full rounded-xl ${
                      canEdit
                        ? "hover:bg-primary-dark"
                        : "cursor-not-allowed opacity-50"
                    }`}
                    onClick={() => editCard(cardDetails)} // Edit button functionality
                  >
                    Edit
                  </button>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Status:</label>
                  <span
                    className={`capitalize ml-2 p-1 rounded text-sm ${
                      cardDetails.cardStatus === "completed"
                        ? "bg-green-200 text-green-800"
                        : "bg-orange-200 text-orange-800"
                    }`}
                  >
                    {cardDetails.cardStatus}
                  </span>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Recipient:</label>
                  <div className="ml-2 p-1 rounded bg-blue-100 text-blue-800">
                    {selectedRecipient}
                  </div>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Event:</label>
                  <div className="ml-2 p-1 rounded bg-orange-100 text-orange-800">
                    {eventName}
                  </div>
                </div>
                <div className="space-y-1">
                  <label className="font-bold">Event Date:</label>
                  <div className="ml-2 p-1 rounded bg-teal-100 text-teal-800">
                    {eventDateWithCurrentYear &&
                      format(eventDateWithCurrentYear, "do MMM yyyy")}
                  </div>
                </div>
              </div>
              <div className="relative flex flex-col items-center justify-center w-full md:w-1/2">
                {imageLoading[currentPage] && (
                  <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center bg-white bg-opacity-75 z-10">
                    <Spinner props="Loading..." size={"50px"} />
                  </div>
                )}
                <div
                  className="image-display mb-1"
                  style={{
                    maxWidth: "5in",
                    maxHeight: "7in",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "24px",
                    fontWeight: "bold",
                  }}
                >
                  <img
                    src={getImgSrc(currentPage)}
                    alt={`Page ${currentPage + 1} Image`}
                    className="rounded-xl shadow-lg max-w-xs h-auto"
                    style={{ maxWidth: "70%", maxHeight: "100%" }}
                    onLoad={() => handleImageLoad(currentPage)}
                    onError={() => handleImageLoad(currentPage, true)}
                  />
                </div>
                <div className="slider-controls flex justify-center">
                  <button
                    onClick={() => setCurrentPage((currentPage - 1 + 3) % 3)}
                    className="mx-2 py-1 px-4 rounded-full bg-gray-300 hover:bg-gray-400"
                    aria-label="Previous image"
                  >
                    {"<"}
                  </button>
                  <span className="px-4 py-2 text-lg font-semibold text-gray-700 rounded-xl">
                    {currentPage + 1} / 3
                  </span>
                  <button
                    onClick={() => setCurrentPage((currentPage + 1) % 3)}
                    className="mx-2 py-1 px-4 rounded-full bg-gray-300 hover:bg-gray-400"
                    aria-label="Next image"
                  >
                    {">"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
      <div className="w-full md:ml-8 xl:pl-[20%] sm:pl-0 pt-[6rem] p-4">
        <WarningCard
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          currentMonthCompletedLength={currentMonthCompletedLength}
          isLoading={isLoading}
          currentUser={currentUser}
          cardsLimit={cardsLimit}
          upcomingMonthCompletedLength={upcomingMonthCompletedLength}
        />
        {/* {currentMonthCompletedLength && !isLoading && !currentUser?.isSubscribed && (
          <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4">
            <p className="font-semibold">Important Notice:</p>
            <p>
              Your subscription has expired. All the cards scheduled for this
              month will not be printed unless you renew your subscription.
              Please take the necessary action to avoid interruptions.
            </p>
          </div>
        )} */}
        <h1 className="mb-2 text-3xl sm:text-4xl font-bold text-center text-secondary sm:text-left">
          Pick Your Cards
        </h1>
        <div className="flex flex-col items-start justify-between gap-5 lg:flex-row lg:gap-0">
          <div className="flex flex-col lg:w-[35%] w-full">
            <div className="flex items-center w-full gap-x-4">
              <select
                value={selectedMonthFilter}
                onChange={(e) => setSelectedMonthFilter(e.target.value)}
                className="w-full py-3 border-b-2 bg-white border-primary placeholder:text-gray-300 focus:border-primary active:border-primary"
              >
                <option value="">Filter by Month</option>
                {filteredYearData &&
                  Object.entries(filteredYearData).map(([year, monthData]) =>
                    Object.entries(monthData).map(([month, cards]) => (
                      <option
                        key={`${year}-${month}`}
                        value={`${year}-${month}`}
                      >
                        {month} {year}
                      </option>
                    ))
                  )}
              </select>
            </div>
          </div>
          <div className="flex items-center lg:w-[35%] w-full justify-center">
            {/* <label className="switch">
              <input
                className="mr-2 mt-[0.3rem] h-3.5 w-8 appearance-none rounded-[0.4375rem] bg-neutral-300 before:pointer-events-none before:absolute before:h-3.5 before:w-3.5 before:rounded-full before:bg-transparent before:content-[''] after:absolute after:z-[2] after:-mt-[0.1875rem] after:h-5 after:w-5 after:rounded-full after:border-none after:bg-neutral-100 after:shadow-[0_0px_3px_0_rgb(0_0_0_/_7%),_0_2px_2px_0_rgb(0_0_0_/_4%)] after:transition-[background-color_0.2s,transform_0.2s] after:content-[''] checked:bg-primary checked:after:absolute checked:after:z-[2] checked:after:-mt-[3px] checked:after:ml-[1.0625rem] checked:after:h-5 checked:after:w-5 checked:after:rounded-full checked:after:border-none checked:after:bg-primary checked:after:shadow-[0_3px_1px_-2px_rgba(0,0,0,0.2),_0_2px_2px_0_rgb(0,0,0,0.14),_0_1px_5px_0_rgba(0,0,0,0.12)] checked:after:transition-[background-color_0.2s,transform_0.2s] checked:after:content-[''] hover:cursor-pointer focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[3px_-1px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-5 focus:after:w-5 focus:after:rounded-full focus:after:content-[''] checked:focus:border-primary checked:focus:bg-primary checked:focus:before:ml-[1.0625rem] checked:focus:before:scale-100 checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:bg-neutral-600 dark:after:bg-neutral-400 dark:checked:bg-primary- dark:checked:after:bg-primary dark:focus:before:shadow-[3px_-1px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[3px_-1px_0px_13px_#3b71ca]"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                checked={showPast}
                onChange={() => setShowPast((prev) => !prev)}
              />
              <span className="slider round"></span>
            </label>
            <span className="ml-2"> */}
            <div className="flex items-center w-full justify-end">
              <button
                onClick={() => {
                  setTabClick("Past");
                  setSelectedMonthFilter("");
                }}
                className={`px-4 py-2 rounded-none transition-all ${
                  tabclick === "Past"
                    ? "bg-primary text-white" // Apply primary bg and text for active tab
                    : "bg-transparent text-primary border border-primary" // Default style
                }`}
              >
                Past
              </button>
              <button
                onClick={() => {
                  setTabClick("Current");
                  setSelectedMonthFilter("");
                }}
                className={`px-4 py-2 rounded-none transition-all ${
                  tabclick === "Current"
                    ? "bg-primary text-white"
                    : "bg-transparent text-primary border  border-r-0  border-l-0 border-primary"
                }`}
              >
                Current
              </button>
              <button
                onClick={() => {
                  setTabClick("Upcoming");
                  setSelectedMonthFilter("");
                }}
                className={`px-4 py-2 rounded-none transition-all ${
                  tabclick === "Upcoming"
                    ? "bg-primary text-white"
                    : "bg-transparent text-primary border border-primary"
                }`}
              >
                Upcoming
              </button>
            </div>
            {/* </span> */}
          </div>
        </div>
        {loader ? (
          <div
            className="flex items-center justify-center"
            style={{ height: "calc(100vh - 15rem)" }}
          >
            <Spinner props="Loading..." size={80} />
          </div>
        ) : filteredYearData === null ? (
          <div className="flex flex-col items-center justify-center h-full my-auto">
            <img src={draft_img} alt="draft" width={400} />
            <h3 className="my-10 text-xl">
              Empty in drafts, generate a card and save it to drafts.
            </h3>
          </div>
        ) : (
          // {filteredYearData && Object.entries(filteredYearData).map(([year, monthData]) =>
          //   Object.entries(monthData).map(([month, cards]) => (
          Object.entries(filteredYearData).map(([year, monthData]) => {
            return (
              <div key={year}>
                {monthData === null ? (
                  <div>No data</div>
                ) : (
                  Object.entries(monthData).map(([month, cards]) => (
                    <div key={`${month}-${year}`} className="mb-4">
                      <h1 className="text-xl md:text-2xl font-bold my-2">
                        {month} {year !== "past" && year}
                      </h1>
                      <div className="px-4 py-2 mb-6 bg-gray-100 rounded-xl shadow-sm">
                        <MultiSwiper reffs={month} key={month}>
                          {cards?.map((card, index) => {
                            const eventObject = occasions?.find(
                              (el) => el._id === card.eventId
                            );
                            const adjustedEventDate = getAdjustedEventDate(
                              card?.eventDate,
                              card?.createdAt,
                              eventObject,
                              card
                            );
                            const daysDifference = getDateDifferenceInDays(
                              new Date(),
                              adjustedEventDate
                            );
                            const rawEventDate = new Date(daysDifference);
                            const currentDate = new Date();
                            const isSameMonth =
                              rawEventDate.getMonth() ===
                                currentDate.getMonth() &&
                              rawEventDate.getFullYear() ===
                                currentDate.getFullYear();
                            const isPastButSameMonth =
                              rawEventDate < currentDate && isSameMonth;

                            return (
                              <SwiperSlide key={index}>
                                <div
                                  className={`relative w-full ${
                                    daysDifference < 7 &&
                                    card?.status !== "completed" &&
                                    !isPastButSameMonth
                                      ? "opacity-50 pointer-events-none"
                                      : ""
                                  }`}
                                >
                                  <div className="relative w-full">
                                    <div className="relative">
                                      <img
                                        src={card?.cardId?.thumbnail}
                                        alt="Card thumbnail"
                                        className={`border-4 
                                          ${
                                            card?.cartStatus === "purchased"
                                              ? "border-red-500 rounded-lg"
                                              : ""
                                          } 
                                          ${
                                            card?.status === "completed"
                                              ? "border-primary"
                                              : ""
                                          } 
                                          w-full shadow-lg cursor-pointer`}
                                        onClick={() => {
                                          setSelectedRecipient(
                                            card?.receiptsId?.fullName
                                          );
                                          setCurrentEventId(card?.eventId);
                                          setEventDate(card?.eventDate);
                                          setCardDetails({
                                            textCard: card?.textCard,
                                            cardStatus: card?.status,
                                            textTo: card?.textTo,
                                            textFrom: card?.textFrom,
                                            messageTheme: card?.messageTheme,
                                            createdAt: card?.createdAt,
                                            cardId: card?.cardId,
                                            receiptsId: card?.receiptsId,
                                            eventId: card?.eventId,
                                            eventOfRecipientId: card?._id,
                                            eventDate: card?.eventDate,
                                          });
                                          setSelectedCardThumbnail(
                                            card?.cardId?.thumbnail
                                          );
                                          fetchCardDetails(
                                            card?.textTo,
                                            card?.textCard,
                                            card?.textFrom
                                          );
                                          setDetailsModal(true);
                                        }}
                                      />
                                    </div>
                                    <div className="absolute top-0 right-0 bg-black bg-opacity-75 text-white px-2 py-1">
                                      {format(
                                        adjustedEventDate,
                                        year === "past" ? "do MMM" : "do MMM"
                                      )}
                                    </div>
                                    {daysDifference > 7 &&
                                      card?.status !== "completed" && (
                                        <div
                                          onClick={() => {
                                            setCardToBeDelete(card);
                                            toggleRemoveModal();
                                          }}
                                          className="absolute top-0 left-0 bg-primary bg-opacity-35 border rounded-full text-white p-2 cursor-pointer"
                                        >
                                          <Tooltip
                                            text="Delete this card"
                                            position="bottom-left"
                                          >
                                            <IoCloseSharp />
                                          </Tooltip>
                                        </div>
                                      )}
                                    {new Date(card?.frozenDate) < currentDate &&
                                      (card?.status === "completed" ||
                                        card?.status === "printed") && (
                                        <div
                                          onClick={() => {
                                            setCardToBeDelete(card);
                                            toggleRemoveModal();
                                          }}
                                          className="absolute top-0 left-0 bg-primary bg-opacity-35 border rounded-full text-white p-2 cursor-pointer z-50 pointer-events-auto"
                                        >
                                          <Tooltip
                                            text="Delete this card"
                                            position="bottom-left"
                                          >
                                            <IoCloseSharp />
                                          </Tooltip>
                                        </div>
                                      )}
                                    {orderLoader === card?._id ? (
                                      <div className="w-full mt-3">
                                        <Spinner props={""} size={"50px"} />
                                      </div>
                                    ) : (
                                      <button
                                        onClick={() => {
                                          if (card?.cartStatus === "addToCart")
                                            return;

                                          if (
                                            card?.status === "completed" &&
                                            daysDifference >= 7
                                          ) {
                                            handleOrder(
                                              card?._id,
                                              "cancel",
                                              card?.customerId
                                            );
                                          } else {
                                            if (!currentUser?.isSubscribed) {
                                              handleAddToCart(card);
                                              return;
                                            }
                                            if (
                                              tabclick === "Upcoming" &&
                                              handleUpcomingMonthComplete(
                                                month,
                                                monthData
                                              )
                                            ) {
                                              setIsPopupOpen(true); // Open the popup
                                              return;
                                            } else if (
                                              tabclick === "Current" &&
                                              handleUpcomingMonthComplete(
                                                month,
                                                monthData
                                              )
                                            ) {
                                              setIsPopupOpen(true); // Open the popup
                                              return;
                                            }

                                            handleOrder(
                                              card?._id,
                                              "place",
                                              card?.customerId,
                                              adjustedEventDate
                                            );
                                          }
                                        }}
                                        disabled={
                                          card?.cartStatus === "addToCart" ||
                                          card?.cartStatus === "purchased" ||
                                          (daysDifference < 7 &&
                                            card?.status !== "completed") ||
                                          (daysDifference < 7 &&
                                            card?.status === "completed")
                                        }
                                        className={`w-full py-2 mt-3 border-2 rounded-md
                                           ${
                                             card?.cartStatus === "addToCart"
                                               ? "cursor-not-allowed bg-gray-300 text-gray-500 border-gray-300"
                                               : ""
                                           }${
                                          card?.cartStatus === "purchased"
                                            ? "cursor-not-allowed bg-gray-300 text-red-500 border-gray-300"
                                            : ""
                                        }   ${
                                          daysDifference < 7 &&
                                          card?.status !== "completed"
                                            ? "cursor-not-allowed bg-gray-300 text-gray-500 border-gray-300"
                                            : "border-primary text-primary hover:bg-primary-light"
                                        } ${
                                          showPast
                                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                            : card?.status === "completed"
                                            ? daysDifference >= 7
                                              ? "border-primary text-primary hover:bg-primary-light"
                                              : "cursor-not-allowed bg-gray-300 text-gray-500 border-gray-300"
                                            : "border-primary text-primary hover:bg-primary-light"
                                        }`}
                                      >
                                        {card?.cartStatus === "addToCart" ? (
                                          <span className="text-green-600 ">
                                            Added
                                          </span>
                                        ) : card?.cartStatus === "purchased" ? (
                                          <span className="text-blue-600 opacity-60 cursor-not-allowed">
                                            Scheduled
                                          </span>
                                        ) : !currentUser?.isSubscribed ? (
                                          <span>Add to Cart</span>
                                        ) : showPast ? (
                                          <span>
                                            <FontAwesomeIcon icon={faTimes} />{" "}
                                            Not Available
                                          </span>
                                        ) : card?.status === "completed" ? (
                                          daysDifference >= 7 ? (
                                            <span className="text-gray-500">
                                              Cancel
                                            </span>
                                          ) : (
                                            <span className="cursor-not-allowed text-gray-500">
                                              Can't Order
                                            </span>
                                          )
                                        ) : daysDifference >= 7 ? (
                                          "Schedule"
                                        ) : (
                                          "Can't Order"
                                        )}
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </MultiSwiper>
                      </div>
                    </div>
                  ))
                )}
              </div>
            );
          })
        )}
      </div>
      {isModalOpen && (
        <Modal toggleRemoveModal={toggleModal}>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-secondary w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
              <h1 className="text-2xl text-white capitalize">
                {/* {occasion} Confirmation */}
                Upgrade Subscription Plan
              </h1>
              <IoMdClose
                size={30}
                color="white"
                className="cursor-pointer"
                onClick={toggleModal}
              />
            </div>
            <div className="flex flex-col items-center w-[80%] justify-center p-5 m-10 border-2 border-black border-dashed rounded-lg">
              <p className="my-3 text-lg text-center">
                {/* The selected {occasion} is within the next 7 days. It will be
                      moved to next year. Do you want to continue? */}
                Please upgrade your subscription in order to schedule your cards
              </p>
              <div className="flex items-center justify-center w-full text-xl gap-x-4 mt-4">
                <button
                  className="flex items-center justify-center px-8 py-2 border-2 rounded-sm border-primary text-primary hover:bg-primary-light gap-x-2"
                  onClick={toggleModal}
                >
                  {/* <IoMdClose size={30} /> */}
                  <span className="font-medium">No</span>
                </button>
                {false ? (
                  <div>
                    <Spinner props={""} size={"50px"} />
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      // handleSubmit("pending");
                      navigate("/dashboard/premium_plan");
                    }}
                    className="flex items-center justify-center px-8 py-2 text-white border-2 rounded-sm bg-primary hover:bg-primary-dark border-primary gap-x-2"
                  >
                    {/* <IoCheckmark size={30} /> */}
                    <span className="font-medium">Subscribe</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      )}
      {/* <CartSidebar
      updateCardStatusLocally={updateCardStatusLocally}/> */}
      {removeModal && (
        <ConfirmationModal
          title="Delete Card"
          message="Are you sure you want to delete this Card?"
          imageSrc={remove_recipient}
          onConfirm={() => {
            handleDeleteCard(
              cardToBeDelete._id,
              cardToBeDelete.customerId,
              setCardToBeDelete,
              toggleRemoveModal,
              setLoader,
              fetchCards
            );
          }}
          onCancel={toggleRemoveModal}
          confirmText={loader ? <Spinner size={"50"} /> : "Yes"}
          cancelText="No"
          toggleModal={toggleRemoveModal}
        />
      )}
    </section>
  );
};

export default SendToPrint;

const WarningCard = ({
  isOpen,
  onClose,
  cardsLimit,
  currentMonthCompletedLength,
  upcomingMonthCompletedLength,
}) => {
  if (!isOpen) return null; // Render nothing if the popup is not open

  return (
    <Modal toggleRemoveModal={onClose}>
      <div className="flex flex-col items-center justify-center">
        <div className="bg-secondary w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
          <h1 className="text-2xl text-white">Card Limit</h1>
          <IoMdClose
            size={30}
            color="white"
            className="cursor-pointer"
            onClick={onClose}
          />
        </div>
        <div className="flex flex-col items-center w-[80%] justify-center p-5 m-10 border-2 border-black border-dashed rounded-lg">
          <IoWarningOutline size={50} color="" className="mb-4 text-primary" />
          <p className="my-3 text-lg text-center">
            You have reached your <strong>{cardsLimit}</strong> card limit,
            please deselect some cards to proceed
            {/* cards completed. */}
          </p>
          {/* <p className="text-center">Please deselect some cards to proceed.</p> */}
          <div className="flex items-center justify-center w-full text-xl gap-x-4 mt-6">
            <button
              className="flex items-center justify-center px-8 py-2 border-2 rounded-sm border-primary text-primary hover:bg-primary-light gap-x-2"
              onClick={onClose}
            >
              <IoMdClose size={30} />
              <span className="font-medium">Close</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
